import { render, staticRenderFns } from "./PromotionItemSelector.vue?vue&type=template&id=5ac81495&scoped=true&"
import script from "./PromotionItemSelector.vue?vue&type=script&lang=ts&"
export * from "./PromotionItemSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac81495",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
